export function Loader() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand border-t-transparent" />
    </div>
  );
}

export function EmptyState({ title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <h3 className="font-heading text-2xl text-brand-dark">{title}</h3>
      {subtitle && <p className="mt-2 max-w-sm text-brand-muted">{subtitle}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
